import { VehicleDriverSideIcon } from '@THC/components/Icons/VehicleDriverSide';
import { MDText } from 'i18n-react';

import LocalTexts from './Placeholder.text.json';

import styles from './Placeholder.module.scss';

const LocalT = new MDText(LocalTexts);

export const Placeholder: React.FC = () => {
	return (
		<div className={styles.placeholder}>
			<VehicleDriverSideIcon />
			<h3 className={styles.text}>{LocalT.translate('text')}</h3>
		</div>
	);
};
